<div class="container-fluid title-header-cont">
  <div class="row">
    <div class="col-md-12">
      <div class="title-header">
        <div class="title">
          Watchlist

          <div class="btn-group toggle-filter ml-4" role="group" aria-label="Watchlist Type">
            <button type="button" class="btn btn-secondary"
                    [ngClass]="{'active': currentConfig?.key === 'ctv'}"
                    (click)="changeType('ctv')">
              Connected TV<span class='badge badge-pill ml-2'>{{ getFollowCountByType( 'ctv' ) }}</span>
            </button>
            <button type="button" class="btn btn-secondary"
                    [ngClass]="{'active': currentConfig?.key === 'apps'}"
                    (click)="changeType('apps')">
              Mobile Apps<span class='badge badge-pill ml-2'>{{ getFollowCountByType( 'apps' ) }}</span>
            </button>
            <!-- <button type="button" class="btn btn-secondary"
                    [ngClass]="{'active': currentConfig?.key === 'domains'}"
                    (click)="changeType('domains')">
              Domains<span class='badge badge-pill ml-2'>{{ getFollowCountByType( 'domains' ) }}</span>
            </button> -->
          </div>

          <div class="triangle"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class='right-content discovery'
     *ngIf='notAllowed'>
  You do not have permission to access this data.
</div>
<div class="right-content discovery"
     *ngIf="!notAllowed">
  <div class="right-content-inner">
    <div class="tabbed-filters-cont"></div>
    <div class="container-fluid main-content" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
      <div class="d-flex flex-row flex-wrap justify-content-between summary-heading">
        <div class="canned-filter-title">
          <h5 class="d-flex align-items-center" style="text-transform: none">
              <span [hidden]="loading || loadingData">
                <span *ngIf="totalCount > 0">You are following {{totalCount | num}} {{pluralize( prettyNameTypeMapping[ currentConfig?.key ], totalCount )}}.</span>
                <span *ngIf="totalCount === 0">You are not following any {{prettyNameTypeMapping[ currentConfig?.key ]}}.</span>
              </span>
            <div class="loader d-inline" data-loader="circle-side"></div>
          </h5>
        </div>
      </div>

      <app-app-list-view *ngIf='totalCount > 0'
                         [reportViewType]="'list'"
                         [showFollowing]="true"
                         [searchEnabled]="false"
                         [currentConfig]="currentConfig"
                         [showDetails]="false"
                         [gridData]="gridData"
                         [showLoadMore]="showLoadMore"
                         [showLoadingMore]="showLoadingMore"
                         [appGlobalSearchParamModel]="activeSearchQuery"
                         (loadMoreClick)="loadMore()"
                         (unfollowItem)="unfollowItem($event)"
                         (toggleSortClick)="toggleSort($event)"
                         (appGlobalSearch)="appGlobalSearch($event)"
                         (clearAppGlobalSearch)="clearAppGlobalSearch()">
      </app-app-list-view>

    </div>
  </div>
</div>
